import {Component} from '@angular/core';
import {NgOptimizedImage} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-download-app',
  imports: [NgOptimizedImage, TranslatePipe],
  templateUrl: './download-app.html',
})
export class DownloadApp {

}
